<template><div class="cms-dynamic-page"></div></template>
<script>
export default {
  name: 'CmsDynamicPage',
  head() {
    const page = this.$store.state.cms.page
    const seo = page ? page.seo : { title: '页面不可用' }
    return { title: seo.title, meta: [{ name: 'description', content: seo.description || '' }, { name: 'keywords', content: seo.keywords || '' }] }
  }
}
</script>
